module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "ackn"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Acknowledgments")])])]), _c('a', {
    attrs: {
      "id": "ackn"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I couldn’t have written this book without the help of two very special people. Firstly, my husband, Sebag. I knew my story, but I couldn’t work out how to fit all the pieces of my plot together. Sebag paced up and down the kitchen floor of our cottage while I hugged a mug of tea and wrote notes. We tossed about ideas as the day melted into evening … and then the plot began to take shape. Finally, as the moon settled high in the sky and the owls began to hoot, we put it to bed—exhausted! However, there was one problem—good though we thought it was, we couldn’t work out how to pull off the central twist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For such a technical problem I needed an expert. I called upon the experience of my old university friend, Charlie Carr—an investigator. Thank you, Charlie, for slicing through the Gordian knot—it seems so simple in retrospect, but all the best plots do! I couldn’t have done it without you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And thank you, Sebag, for once again being my Sherlock Holmes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A large part of this story takes place in Tuscany. I lived in Italy in my early twenties, but that doesn’t prevent me from making terrible errors. So, I sought the help of my trusty Italian friends. I thank them all: Eduardo Teodorani Fabbri, Stefano Bonfiglio, and Sofia Barattieri di san Pietro.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I was considering where to set my story, I went to stay with Olga Polizzi at her enchanting country house hotel, Endsleigh. There is something magical about Endsleigh. Snuggled deep in the Devon countryside, it is built above a winding river and sheltered by ancient trees. Olga has flair and warmth so Endsleigh feels more like a home than a hotel—and I felt right at home there! It was autumn. Giant log fires filled the rooms with the cozy smell of woodsmoke and clusters of tea lights in purple glass tumblers glowed on every surface. The atmosphere was soft and embracing, and I didn’t want to leave.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ackn"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("So, I have based my hotel, the Polzanze, on Endsleigh, and hope that I have channeled some of its spirit. I thank Olga for inspiring me because with two small children it’s hard for me to travel, so inspiration is in short supply—I have to rely on memories. But there is nothing as invigorating as discovering new and wonderful places.")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Everything I write comes out of the great big cauldron that contains all my life’s experiences. If it is rich, it is thanks to my parents, Charles and Patty Palmer-Tomkinson. I couldn’t have written a single word without their wisdom, guidance, and love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I want to give special thanks to my agent, Sheila Crowley. Tireless in her support and always positive, she’s a valuable ally and a good friend. The team at Curtis Brown are buzzing with energy and enthusiasm, and I thank them all for the work they do on my behalf.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am fortunate enough to be published by Simon & Schuster on both sides of the Atlantic. I have two dynamic editors, Suzanne Baboneau in the U.K. and Trish Todd in the United States. Both steer me in the right direction and bring out the best that I can give. I’m so grateful for their belief in my writing and their astute and sensitive editing.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("I would also like to thank Libby Yevtushenko for working so hard on the manuscript and improving it with intelligence and tact.")]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-419e2147","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ackn.vue
// module id = 72
// module chunks = 0